import { jitsiLocalStorage } from '@jitsi/js-utils';
import i18next from 'i18next';
import $ from 'jquery';
import { sha256 } from 'js-sha256';
import _ from 'lodash';
import MetisMenu from 'metismenujs';
import 'metismenujs/style';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import MediaQuery from 'react-responsive';

import {
    MyCalyIcon,
    VideoIcon
} from '../../../../static/assets/vendor/svgIcons/svgIcons';
import { Avatar } from '../../base/avatar';
import { apiKEY } from '../../base/config/constants';
import { JWT_STORAGE, SET_ACCESS_TOKEN } from '../../base/jwt/actionTypes';
import { fetchAxiosApi, setJWTforGuest, setuserDetails } from '../../base/mtApi';
import { Watermark } from '../../base/react';
import { getDisplayName, updateSettings } from '../../base/settings';
import {
    getBackendSafeRoomName,
    parseURLParams,
    sliceLengthyCharacters
} from '../../base/util';
import { isDomainWeborNative } from '../../base/util/checkOS';
import LanguagesDropdown from '../../languages-component/components/LanguagesDropdown';

import { styleWeb } from './stylesWeb';

const _inlineStyles = {
    _s0: { paddingTop: '5px',
        marginBottom: '10px' },
    _s1: {
        padding: '0px 25px 0px 5px'
    },
    _s2: {
        padding: '0px 12px'
    },
    _s3: {
        background: '#415d86'
    },
    _s4: {
        display: 'flex',
        alignItems: 'center'
    },
    _s5: {
        marginLeft: '15px'
    },
    _s6: {
        padding: '0px 20px'
    },
    _s7: {
        display: 'flex',
        alignItems: 'end'
    },
    _s8: {
        height: '26px',
        width: '26px',
        border: 'none',
        borderRadius: 'unset'
    },
    _s9: {
        padding: '20px'
    },
    _s10: {
        paddingRight: '15px'
    },
    _s11: {
        display: 'flex',
        alignItems: 'baseline'
    },
    _s12: {
        paddingLeft: '30px'
    },
    _s13: {
        padding: '8px 0px'
    },
    _s14: {
        padding: '0px 24px'
    }
};

declare var config: object;

export const Header = props => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [ userd, setUserd ] = useState(undefined);
    const [ rmoveImg, setrmoveImg ] = useState(false);
    const [ isOpen, setIsOpen ] = useState(false);
    const menuRef = useRef(null);
    const [ isToggled, setToggled ] = useState(false);
    const [ , setIsHovered ] = useState(false);
    const toggleTrueFalse = () => {
        setToggled(!isToggled);
        const sidemenuButton = document.getElementById('sidebar-toggle');

        if (sidemenuButton) {
            if (isToggled) {
                sidemenuButton.classList.remove('open');
                setIsHovered(false);
            } else {
                sidemenuButton.classList.add('open');
            }
        }
    };

    const handleMouseEnter = () => {
        if (isToggled) {
            setIsHovered(true);
        }
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    const [ loginButton, setLoginButton ] = useState(false);
    const [ , ] = useState(false);

    const { interfaceConfig } = useSelector(
    state => state['features/base/config']
    );
    const state1 = useSelector(state => state['features/base/jwt']);
    const name = useSelector(state => getDisplayName(state));
    const { userDetails, pregData } = useSelector(
    state => state['features/base/mtApi']
    );

    const userAccessToken = jitsiLocalStorage.getItem('accessToken');
    const roomName = getBackendSafeRoomName(
    useSelector(state => state['features/base/conference'].room)
    );
    const { locationURL } = useSelector(
    state => state['features/base/connection']
    );

    // menu code start

    //  let mobilebrower =  isMobileBrowser();

    useEffect(() => {
    // Function to close the menu when clicking outside
        const handleClickOutside = event => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        // Attach the event listener when the menu is open
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            // Remove the event listener when the menu is closed
            document.removeEventListener('mousedown', handleClickOutside);
        }

        if (document.querySelector('#metismenu')) {
            void new MetisMenu('#metismenu');
        }

        // Cleanup when the component unmounts
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ isOpen ]);

    const testMouseOut = () => {
        setrmoveImg(false);
    };

    const testMouseOver = () => {
        setrmoveImg(true);
    };

    //   menu code end

    useEffect(() => {
        let accesTokn = state1.accessToken ?? userAccessToken;
        const urlTest = locationURL?.pathname?.length;

        if (urlTest <= 1) {
            document.body.style.overflowY = 'hidden';
        }

        const urrr = parseURLParams(locationURL, true, 'search');

        if (
            urrr?.logout
      && urrr?.client_id
      && urrr?.client_id === config?.MH_CLIENT_ID
        ) {
            dispatch(setuserDetails(undefined));
            accesTokn = undefined;
            jitsiLocalStorage.clear();
            const ele
        = document.getElementById('preloader')
        ?? document.getElementById('preloader1');

            if (ele) {
                setTimeout(() => {
                    ele.style.opacity = '0';
                    document.body.style.overflowY = 'scroll';
                    setTimeout(() => {
                        ele.style.display = 'none';
                    }, 2000);
                }, 1500);
            }
        }

        if (
            (_.isNil(userDetails) && pregData && accesTokn)
      || Boolean(_.isNil(userDetails) && urlTest <= 1 && accesTokn)
        ) {
            const moement = moment().seconds(0)
.milliseconds(0)
.format('X');

            const mesh256 = sha256(`${apiKEY}:MH:${moement}`);

            const preRegObject = JSON.stringify({
                client_id: config.MH_CLIENT_ID,
                credentials: mesh256,
                ...isDomainWeborNative,
                meeting_id: roomName
            });

            fetchAxiosApi(
        'customer/user_details',
        {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${state1.accessToken ?? userAccessToken}`
            },
            body: preRegObject
        })
        .then(response => {
            const isTrueReg: boolean = Boolean(pregData?.is_pre_registration);

            // const isTrueGuest: boolean = Boolean(preRegData?.allow_guest === 1);
            const { jwt = '' } = response?.data ?? {};

            // This for the case when default language English is
            // changed by integration customers and we do not want to overwrite with user_details api.
            if (config?.defaultLanguage === 'en') {
                const langPref = response?.data?.strip_details?.language_preference;
                const normalizedLang = langPref === 'in' ? 'hi' : langPref;

                i18next.changeLanguage(normalizedLang);
            }

            // Also Skipping the pre-registration page redirect for Recorder

            if (
                isTrueReg
            && !state1.jwt
            && !state1.jwtData
            && _.isEmpty(jwt)
            && !config?.iAmRecorder === true
            ) {
                return window.location.replace(
              `${
                  config?.brandedPreRegistrationURL
                      ? config?.brandedPreRegistrationURL
                      : pregData.registration_url
              }`
                );
            }
            setUserd(response.data);
            const namess = response?.data?.name;
            const emailss = response?.data?.email;
            const pict = response?.data?.picture;

            dispatch(
            updateSettings({
                avatarURL: pict,
                displayName: namess,
                email: emailss
            })
            );

            if (response.success) {
                setLoginButton(true);
                dispatch({
                    type: SET_ACCESS_TOKEN,
                    accessToken: state1.accessToken ?? userAccessToken
                });
                const getJwt = response.data?.jwt;

                if (!_.isEmpty(getJwt) && !state1?.jwt) {
                    dispatch({
                        type: JWT_STORAGE,
                        jwtData: getJwt
                    });
                }
                if (
                    _.isEmpty(getJwt)
              && !state1?.jwt
              && !state1.jwtData
              && urlTest >= 1
              && interfaceConfig?.applyMeetingSettings === true
                ) {
                    dispatch(setJWTforGuest());
                }
            } else {
                jitsiLocalStorage.removeItem('accessToken');
            }
            const ele
            = document.getElementById('preloader')
            ?? document.getElementById('preloader1');

            if (ele) {
                setTimeout(() => {
                    ele.style.opacity = '0';
                    document.body.style.overflowY = 'scroll';
                    setTimeout(() => {
                        ele.style.display = 'none';
                    }, 2000);
                }, 1500);
            }

            dispatch(setuserDetails(response.data));
        })
        .catch(() => {
            const ele
            = document.getElementById('preloader')
            ?? document.getElementById('preloader1');

            if (ele) {
                setTimeout(() => {
                    ele.style.opacity = '0';
                    document.body.style.overflowY = 'scroll';
                    setTimeout(() => {
                        ele.style.display = 'none';
                    }, 2000);
                }, 1500);
            }
        });
        }

        const isTrueReg: boolean = Boolean(pregData?.is_pre_registration);

        // // const isTrueGuest: boolean = Boolean(preRegData?.allow_guest === 1);

        // Also Skipping the pre-registration page redirect for Recorder
        if (
            isTrueReg
      && !state1.jwt
      && !state1.jwtData
      && !accesTokn
      && !config?.iAmRecorder === true
      && parseURLParams(locationURL)?.mt === undefined
        ) {
            window.location.href = `${pregData.registration_url}`;

            return;
        }

        if (!accesTokn && loginButton === false) {
            const ele
        = document.getElementById('preloader')
        ?? document.getElementById('preloader1');

            if (ele) {
                setTimeout(() => {
                    ele.style.opacity = '0';
                    document.body.style.overflowY = 'scroll';
                    setTimeout(() => {
                        ele.style.display = 'none';
                    }, 2500);
                }, 2000);
            }
        }

        if (userDetails) {
            setLoginButton(true);
        }
    }, [ pregData?.success ]);

    const loginButtonJSx = (
        <>
            <li className = 'signin-li'>
                <a
                    href = { `${config.URL_PREFIX}serviceLogin?client_id=${
                        config.MH_CLIENT_ID
                    }&redirect_uri=${window.location.href}${
                        roomName ? '%23interfaceConfig.ENABLE_DESKTOP_DEEPLINK%3Dfalse' : ''
                    }&device_type=web&response_type=get${
                        roomName ? `&meeting_id=${roomName}` : ''
                    }` }>
                    {t('prejoin.signinsignup')}
                </a>
            </li>
        </>
    );

    const loginButtonJSxMobile = (
        <>
            <div className = 'signin-li'>
                <a
                    href = { `${config.URL_PREFIX}serviceLogin?client_id=${
                        config.MH_CLIENT_ID
                    }&redirect_uri=${window.location.href}${
                        roomName ? '%23interfaceConfig.ENABLE_DESKTOP_DEEPLINK%3Dfalse' : ''
                    }&device_type=web&response_type=get${
                        roomName ? `&meeting_id=${roomName}` : ''
                    }` }>
                    {t('prejoin.signinsignup')}
                </a>
            </div>
        </>
    );


    useEffect(() => {
        // Delegated on document, so it outlives this component unless removed. Each mount used to add one more,
        // and with two attached every click toggled the dropdown open and straight back closed.
        const onDropDownClick = e => {
            e.preventDefault();

            $(e.currentTarget).next()
.slideToggle(300);

            $(e.currentTarget).parent()
.toggleClass('active');
        };

        $(document).on('click', '.mobile-nav .drop-down > a', onDropDownClick);

        return () => {
            $(document).off('click', '.mobile-nav .drop-down > a', onDropDownClick);
        };
    }, []);

    /**
   * Event used to logout the user from the app.
   *
   * @param {event} e - Event object..
   * @private
   * @returns {void}
   */
    function logOutClicked(e) {
        e.preventDefault();
        const ele
      = document.getElementById('preloader')
      ?? document.getElementById('preloader1');

        if (ele) {
            ele.style.opacity = '100%';
            ele.style.display = 'flex';
        }
        jitsiLocalStorage.clear();
        window.location.replace(
      `${config.URL_PREFIX}serviceLogin?client_id=${
          config.MH_CLIENT_ID
      }&redirect_uri=${
          window.location.href
      }&device_type=web&response_type=get&access_token=${
          state1.accessToken ?? userAccessToken
              ? `&access_token=${state1.userAccessToken ?? userAccessToken}`
              : ''
      }&logout=true`
        );
        dispatch(setuserDetails(undefined));
        dispatch(
      updateSettings({
          displayName: undefined,
          email: undefined
      })
        );
    }
    let logoutDocument;

    if (loginButton) {
        logoutDocument = (
            <li className = 'drop-down d-flex'>
                {(userd && userd?.picture) || (userDetails && userDetails.picture) ? (
                    <img
                        className = 'avatar'
                        src = { userd?.picture ?? userDetails?.picture }
                        style = { styleWeb.widthandHeight } />
                ) : (
                    <Avatar
                        className = 'premeeting-screen-avatar'
                        displayName = { name }
                        dynamicColor = { true }
                        participantId = 'local'
                        size = { 45 } />
                )}

                <a>
                    {/* `loginButton` outlives the user details: logOutClicked clears them and re-renders before the
                        page navigates away, and a login response sets the button before storing them. When the
                        details came from the store (so `userd` was never fetched), this used to throw. */}
                    {sliceLengthyCharacters({
                        char: userd?.name ?? userDetails?.name ?? '',
                        charLength: 25,
                        shouldBeDotted: true
                    })}
                </a>
                <ul className = 'drop-down1'>
                    <li>
                        <a
                            href = { `${config.URL_PREFIX}serviceLogin?client_id=${
                                config.MH_CLIENT_ID
                            }&redirect_uri=${
                                config.URL_PREFIX
                            }customer/dashboard&device_type=web${
                                state1.accessToken ?? userAccessToken
                                    ? `&access_token=${state1.userAccessToken ?? userAccessToken}`
                                    : ''
                            }` }>
                            <i className = 'bx bxs-dashboard' /> {t('prejoin.dashboard')}
                        </a>
                    </li>
                    <li>
                        <a
                            href = { `${config.URL_PREFIX}serviceLogin?client_id=${
                                config.MH_CLIENT_ID
                            }&redirect_uri=${
                                config.URL_PREFIX
                            }customer/profile&device_type=web${
                                state1.accessToken ?? userAccessToken
                                    ? `&access_token=${state1.accessToken ?? userAccessToken}`
                                    : ''
                            }` }>
                            <i className = 'bx bx-user' /> {t('prejoin.profile')}
                        </a>{' '}
                    </li>
                    <li>
                        <a
                            onClick = { logOutClicked }
                            style = { styleWeb.cusrorPointer }>
                            <i className = 'bx bx-log-out' /> {t('toolbar.logout')}
                        </a>
                    </li>
                </ul>
            </li>
        );
    } else if (props.desktopDeepLink) {
        logoutDocument = '';
    } else if (isToggled) {
        logoutDocument = loginButtonJSxMobile;
    } else {
        logoutDocument = loginButtonJSx;
    }

    const handleSubmenuToggle = e => {
        e.preventDefault();

        const parentLi = e.currentTarget.closest('li');

        if (parentLi) {
            parentLi.classList.toggle('mm-active');
            const submenu = parentLi.querySelector('.submenu');

            if (submenu) {
                submenu.classList.toggle('mm-collapse');
                submenu.classList.toggle('mm-show');
            }
        }
    };

    return (
        <React.Fragment>
            {interfaceConfig
        && interfaceConfig.SHOW_MEET_HOUR_WATERMARK
        && !interfaceConfig.disablePrejoinHeader
        && (config?.MEGAMENU_HEADER === true ? (
            <header
                className = { 'align-items-center' }
                id = 'header-nextjs'>
                <div
                    className = 'container d-flex align-items-center'
                    style = { _inlineStyles._s0 }>
                    <div className = 'logo mr-auto width300'>
                        <Watermark />
                        {config?.MEGAMENU_HEADER === true ? (
                            <div className = 'sidebar__menu d-flex justify-content-end d-lg-none'>
                                <div
                                    className = 'sidebar-toggle-btn-5'
                                    id = 'sidebar-toggle'
                                    onClick = { toggleTrueFalse }
                                    onMouseEnter = { handleMouseEnter }
                                    onMouseLeave = { handleMouseLeave }>
                                    <span className = 'line' />
                                    <span className = 'line' />
                                    <span className = 'line' />
                                    <span className = 'line' />

                                </div>
                            </div>
                        )
                            : ''
                        }
                        {isToggled ? (
                            <div
                                className = { `sidebar__area ${
                                    isToggled ? 'sidebar-opened' : ''
                                }` }>
                                <div className = 'sidebar__wrapper'>
                                    <div className = 'sidebar__content'>
                                        <div className = 'logo mb-40'>

                                            <div className = 'd-flex sidemenu__header'>
                                                <LanguagesDropdown isMobileView = { true } />
                                            </div>
                                        </div>
                                        <hr className = 'hr-class' />

                                        <div className = 'user-profile nav-menu'>
                                            {logoutDocument}
                                        </div>
                                        <div className = { 'mobile-menu mean-container' }>
                                            <nav className = 'mean-nav'>
                                                <ul
                                                    className = 'metismenu text-muted'
                                                    id = 'metismenu'>

                                                    <li>
                                                        <a href = '/'>{t('welcomepage.footer.home')}</a>
                                                    </li>

                                                    <li>
                                                        <a
                                                            className = 'has-arrow'
                                                            href = '/products'
                                                            onClick = { handleSubmenuToggle }>
                                                            {t('welcomepage.header.products')}
                                                        </a>
                                                        <ul className = 'submenu mm-collapse'>
                                                            <li className = 'ml-20'>
                                                                <a
                                                                    className = 'has-arrow'
                                                                    href = 'products/video-conference'
                                                                    onClick = { handleSubmenuToggle }>
                                                                    {t('welcomepage.header.videoConference')}
                                                                </a>
                                                                <ul className = 'submenu mm-collapse'>
                                                                    <li>
                                                                        <a href = '/products/video-conference/free'>
                                                                            {t('welcomepage.header.free', {
                                                                                lng: 'en'
                                                                            })}
                                                                        </a>
                                                                    </li>
                                                                    <li>
                                                                        <a href = '/products/video-conference/pro'>
                                                                            {t('welcomepage.header.pro', {
                                                                                lng: 'en'
                                                                            })}
                                                                        </a>
                                                                    </li>
                                                                    <li>
                                                                        <a href = '/products/video-conference/developer'>
                                                                            {t('welcomepage.header.developer', {
                                                                                lng: 'en'
                                                                            })}
                                                                        </a>
                                                                    </li>
                                                                    <li>
                                                                        <a href = '/products/video-conference/enterprise'>
                                                                            {t('welcomepage.header.enterprise', {
                                                                                lng: 'en'
                                                                            })}
                                                                        </a>
                                                                    </li>
                                                                    <li>
                                                                        <a href = '/products/video-conference/enterprise-selfhost'>
                                                                            {t(
                                            'welcomepage.header.enterpriseSelfHost',
                                            { lng: 'en' }
                                                                            )}
                                                                        </a>
                                                                    </li>
                                                                    <li>
                                                                        <a href = '/products/video-conference/features'>
                                                                            {t('welcomepage.header.features')}
                                                                        </a>
                                                                    </li>
                                                                </ul>{' '}
                                                            </li>

                                                            <li className = 'ml-20'>
                                                                <a
                                                                    href = 'https://mycaly.io/'
                                                                    rel = 'noreferrer'
                                                                    target = '_blank'>
                                                                    {t('welcomepage.header.myCaly', {
                                                                        lng: 'en'
                                                                    })}
                                                                </a>{' '}
                                                            </li>
                                                        </ul>
                                                    </li>
                                                    <li>
                                                        <a
                                                            className = 'has-arrow'
                                                            href = '/solutions'
                                                            onClick = { handleSubmenuToggle }>
                                                            {t('welcomepage.header.solutions')}
                                                        </a>
                                                        <ul className = 'submenu mm-collapse'>
                                                            <li className = 'ml-20'>
                                                                <a
                                                                    className = 'has-arrow'
                                                                    href = '/solutions/usecases'
                                                                    onClick = { handleSubmenuToggle }>
                                                                    {t('welcomepage.header.useCases')}
                                                                </a>
                                                                <ul className = 'submenu mm-collapse'>
                                                                    <li>
                                                                        <a href = '/solutions/usecases/videoconferencing'>
                                                                            {t(
                                            'welcomepage.header.videoConferencing'
                                                                            )}
                                                                        </a>
                                                                    </li>
                                                                    <li>
                                                                        <a href = '/solutions/usecases/livestreaming'>
                                                                            {t(
                                            'welcomepage.header.liveStreaming'
                                                                            )}
                                                                        </a>
                                                                    </li>
                                                                    <li>
                                                                        <a href = '/solutions/usecases/virtualclassrooms'>
                                                                            {t(
                                            'welcomepage.header.liveStreaming'
                                                                            )}
                                                                        </a>
                                                                    </li>
                                                                    <li>
                                                                        <a href = '/solutions/usecases/virtualevents'>
                                                                            {t(
                                            'welcomepage.header.virtualEvents'
                                                                            )}
                                                                        </a>
                                                                    </li>
                                                                    <li>
                                                                        <a href = '/solutions/usecases/ekyc'>
                                                                            {t('welcomepage.header.videoKYC')}
                                                                        </a>
                                                                    </li>
                                                                    <li>
                                                                        <a href = '/solutions/usecases/webinars'>
                                                                            {t('welcomepage.header.webinars')}
                                                                        </a>
                                                                    </li>
                                                                    <li>
                                                                        <a href = '/solutions/usecases/fundraising'>
                                                                            {t(
                                            'welcomepage.header.fundraisingDonateOnline'
                                                                            )}
                                                                        </a>
                                                                    </li>{' '}
                                                                </ul>{' '}
                                                            </li>

                                                            <li className = 'ml-20'>
                                                                <a
                                                                    className = 'has-arrow'
                                                                    href = '/solutions/industries'
                                                                    onClick = { handleSubmenuToggle }>
                                                                    {t('welcomepage.header.industries')}
                                                                </a>
                                                                <ul className = 'submenu mm-collapse'>
                                                                    <li>
                                                                        <a href = '/solutions/industries/edtech'>
                                                                            {t('welcomepage.header.edTech')}
                                                                        </a>
                                                                    </li>{' '}
                                                                    <li>
                                                                        <a href = '/solutions/industries/fitness'>
                                                                            {t('welcomepage.header.fitness')}
                                                                        </a>
                                                                    </li>{' '}
                                                                    <li>
                                                                        <a href = '/solutions/industries/healthcare'>
                                                                            {t('welcomepage.header.telehealth')}
                                                                        </a>
                                                                    </li>
                                                                </ul>{' '}
                                                            </li>
                                                        </ul>
                                                    </li>

                                                    <li>
                                                        <a
                                                            className = 'has-arrow'
                                                            href = '/developers'
                                                            onClick = { handleSubmenuToggle }>
                                                            {t('welcomepage.header.developers')}
                                                        </a>
                                                        <ul className = 'submenu mm-collapse'>
                                                            <li className = 'ml-20'>
                                                                <a
                                                                    className = 'has-arrow'
                                                                    onClick = { handleSubmenuToggle }>
                                                                    {t('welcomepage.header.getStarted')}
                                                                </a>
                                                                <ul className = 'submenu mm-collapse'>
                                                                    <li>
                                                                        <a href = '/developers/sdks'>
                                                                            {t('welcomepage.header.preBuiltSDKs')}
                                                                        </a>
                                                                    </li>
                                                                    <li>
                                                                        <a
                                                                            href = 'https://docs.v-empower.com/docs/MeetHour-API'
                                                                            rel = 'noreferrer'
                                                                            target = '_blank'>
                                                                            {t(
                                            'welcomepage.header.documentation'
                                                                            )}
                                                                        </a>
                                                                    </li>
                                                                </ul>{' '}
                                                            </li>

                                                            <li className = 'ml-20'>
                                                                <a
                                                                    className = 'has-arrow'
                                                                    onClick = { handleSubmenuToggle }>
                                                                    {t('welcomepage.header.resources')}
                                                                </a>
                                                                <ul className = 'submenu mm-collapse'>
                                                                    <li>
                                                                        <a href = '/blog'>
                                                                            {t('welcomepage.header.blog')}
                                                                        </a>
                                                                    </li>{' '}
                                                                    <li>
                                                                        <a href = '/developers/resources/api-status'>
                                                                            {t('welcomepage.header.apiStatus')}
                                                                        </a>
                                                                    </li>{' '}
                                                                    <li>
                                                                        <a
                                                                            href = 'http://kb.meethour.io/category/how-to'
                                                                            rel = 'noreferrer'
                                                                            target = '_blank'>
                                                                            {t(
                                            'welcomepage.header.knowledgeBase'
                                                                            )}
                                                                        </a>
                                                                    </li>
                                                                </ul>{' '}
                                                            </li>
                                                        </ul>
                                                    </li>

                                                    <li>
                                                        <a
                                                            className = 'has-arrow'
                                                            href = '/products/video-conference/pricing'
                                                            onClick = { handleSubmenuToggle }>
                                                            {t('welcomepage.pricing')}
                                                        </a>
                                                        <ul className = 'submenu mm-collapse'>
                                                            <li>
                                                                <a href = '/products/video-conference/pricing'>
                                                                    {t('welcomepage.header.videoConference')}
                                                                </a>{' '}
                                                            </li>
                                                            <li>
                                                                <a
                                                                    href = 'https://mycaly.io/pricing'
                                                                    rel = 'noreferrer'
                                                                    target = '_blank'>
                                                                    {t('welcomepage.header.myCaly', {
                                                                        lng: 'en'
                                                                    })}
                                                                </a>{' '}
                                                            </li>
                                                        </ul>
                                                    </li>
                                                    <li>
                                                        <a href = '/joinmeeting'>
                                                            {t('welcomepage.header.joinAMeeting')}
                                                        </a>
                                                    </li>

                                                    <li>
                                                        <a
                                                            className = 'has-arrow'
                                                            href = 'http://kb.meethour.io/category/how-to'
                                                            onClick = { handleSubmenuToggle }>
                                                            {t('welcomepage.header.help')}
                                                        </a>
                                                        <ul className = 'submenu mm-collapse'>
                                                            <li>
                                                                <a href = 'mailto:hello@meethour.io'>
                                                                    {' '}
                                                                    <i className = 'icon_mail' />{' '}
                                                                    {t('welcomepage.header.eMail')}
                                                                </a>{' '}
                                                            </li>
                                                            <li>
                                                                <a
                                                                    href = 'https://meethour.tawk.help/'
                                                                    rel = 'noreferrer'
                                                                    target = '_blank'>
                                                                    {' '}
                                                                    <i className = 'icon_question_alt2' />{' '}
                                                                    {t('welcomepage.header.helpDesk')}{' '}
                                                                </a>
                                                            </li>

                                                            <li>
                                                                <a href = 'tel:+124-547-689'>
                                                                    {' '}
                                                                    <i className = 'icon_phone' /> +1 (312)
                                      800-9410
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href = '/schedule-a-demo'>
                                                                    {' '}
                                                                    <i className = 'icon_info' />{' '}
                                                                    {t('welcomepage.header.scheduleADemo')}
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </li>

                                                </ul>
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                            : <></>
                        }
                    </div>

                    {interfaceConfig && !interfaceConfig.disablePrejoinHeader && (
                        <>
                            <MediaQuery minWidth = { 992 }>
                                <nav
                                    className = 'nav-menu d-none d-lg-flex desktop-width navbar navbar-expand-lg navbar-light nav-menu-nextjs'
                                    style = { styleWeb.width100 }>
                                    <div className = 'container-fluid'>
                                        <button
                                            aria-controls = 'navbarExampleOnHover'
                                            aria-expanded = 'false'
                                            aria-label = 'Toggle navigation'
                                            className = 'navbar-toggler px-0'
                                            data-mdb-target = '#navbarExampleOnHover'
                                            data-mdb-toggle = 'collapse'
                                            type = 'button'>
                                            <i className = 'fas fa-bars' />
                                        </button>

                                        <div
                                            className = 'collapse navbar-collapse justify-content-between'
                                            id = 'navbarExampleOnHover'>
                                            <ul className = 'navbar-nav ps-lg-0'>
                                                <li className = 'nav-item dropdown dropdown-hover position-static'>
                                                    <a
                                                        aria-expanded = 'false'
                                                        className = 'nav-a dropdown-toggle'
                                                        data-mdb-toggle = 'dropdown'
                                                        href = '/products'
                                                        id = 'navbarDropdown'>
                                                        {t('welcomepage.header.products')}
                                                    </a>
                                                    <div
                                                        aria-labelledby = 'navbarDropdown'
                                                        className = 'dropdown-menu w-100 mt-0'
                                                        style = { _inlineStyles._s1 }>
                                                        <div
                                                            className = 'container'
                                                            style = { _inlineStyles._s3 }>
                                                            <div className = 'row my-4'>
                                                                <div
                                                                    className = 'col-md-6 col-lg-6 mb-3 mb-lg-0'
                                                                    style = { _inlineStyles._s2 }>
                                                                    <div
                                                                        className = 'list-group list-group-flush'
                                                                        style = { _inlineStyles._s3 }>
                                                                        <a
                                                                            className = 'list-group-item list-group-item-action list-active'
                                                                            href = { '/products/video-conference' }
                                                                            onMouseOver = { testMouseOver }>
                                                                            <div
                                                                                style = { _inlineStyles._s4 }>
                                                                                <VideoIcon />
                                                                                <span
                                                                                    style = { _inlineStyles._s5 }>
                                                                                    {t(
                                                'welcomepage.header.videoConference'
                                                                                    )}
                                                                                </span>
                                                                            </div>

                                                                            <span className = 'submenu-sub-text'>
                                                                                {t(
                                              'welcomepage.header.hdQualityVideoConferenceApp'
                                                                                )}
                                                                            </span>
                                                                        </a>

                                                                        <a
                                                                            className = 'list-group-item list-group-item-action list-active'
                                                                            href = { 'https://mycaly.io/' }
                                                                            onMouseOver = { testMouseOut }
                                                                            rel = 'noreferrer'
                                                                            target = '_blank'>
                                                                            <div
                                                                                style = { _inlineStyles._s4 }>
                                                                                <MyCalyIcon />
                                                                                <span
                                                                                    style = { _inlineStyles._s5 }>
                                                                                    {t('welcomepage.header.myCaly', {
                                                                                        lng: 'en'
                                                                                    })}
                                                                                </span>
                                                                            </div>

                                                                            <span className = 'submenu-sub-text'>
                                                                                {t(
                                              'welcomepage.header.appointmentSchedulingVideoConference'
                                                                                )}
                                                                            </span>
                                                                        </a>
                                                                    </div>
                                                                </div>

                                                                <div className = 'col-md-6 col-lg-6 mb-3 mb-lg-0'>
                                                                    {rmoveImg === false ? (
                                                                        <img
                                                                            alt = 'Meet Hour Video Conference'
                                                                            src = 'images/product-thumb.png'
                                                                            width = { 300 } />
                                                                    ) : (
                                                                        <div
                                                                            className = 'list-group list-group-flush'
                                                                            style = { _inlineStyles._s6 }>
                                                                            <h5>
                                                                                {t(
                                              'welcomepage.header.videoConferencePlans'
                                                                                )}
                                                                            </h5>
                                                                            <a
                                                                                className = 'list-group-item list-group-item-action list-active'
                                                                                href = {
                                                                                    '/products/video-conference/free'
                                                                                }>
                                                                                <div
                                                                                    style = { _inlineStyles._s7 }>
                                                                                    <img
                                                                                        src = 'images/free.svg'
                                                                                        style = { _inlineStyles._s8 } />

                                                                                    <span>
                                                                                        {t('welcomepage.header.free', {
                                                                                            lng: 'en'
                                                                                        })}
                                                                                    </span>
                                                                                </div>

                                                                                <span className = 'submenu-sub-text'>
                                                                                    {t(
                                                'welcomepage.header.noTimeLimitGroupCalls'
                                                                                    )}
                                                                                </span>
                                                                            </a>
                                                                            <a
                                                                                className = 'list-group-item list-group-item-action list-active'
                                                                                href = {
                                                                                    '/products/video-conference/pro'
                                                                                }>
                                                                                <div
                                                                                    style = { _inlineStyles._s7 }>
                                                                                    <img
                                                                                        src = 'images/pro.svg'
                                                                                        style = { _inlineStyles._s8 } />
                                                                                    <span>
                                                                                        {t('welcomepage.header.pro', {
                                                                                            lng: 'en'
                                                                                        })}
                                                                                    </span>
                                                                                </div>

                                                                                <span className = 'submenu-sub-text'>
                                                                                    {t(
                                                'welcomepage.header.noAdsRecordingLiveStreaming'
                                                                                    )}
                                                                                </span>
                                                                            </a>
                                                                            <a
                                                                                className = 'list-group-item list-group-item-action list-active'
                                                                                href = {
                                                                                    '/products/video-conference/developer'
                                                                                }>
                                                                                <div
                                                                                    style = { _inlineStyles._s7 }>
                                                                                    <img
                                                                                        src = 'images/developer.svg'
                                                                                        style = { _inlineStyles._s8 } />
                                                                                    <span>
                                                                                        {t(
                                                  'welcomepage.header.developer',
                                                  { lng: 'en' }
                                                                                        )}
                                                                                    </span>
                                                                                </div>

                                                                                <span className = 'submenu-sub-text'>
                                                                                    {t(
                                                'welcomepage.header.integrateVideoCallWithinYourWebsiteApp'
                                                                                    )}
                                                                                </span>
                                                                            </a>

                                                                            <a
                                                                                className = 'list-group-item list-group-item-action list-active'
                                                                                href = {
                                                                                    '/products/video-conference/enterprise'
                                                                                }>
                                                                                <div
                                                                                    style = { _inlineStyles._s7 }>
                                                                                    <img
                                                                                        src = 'images/enterprise.svg'
                                                                                        style = { _inlineStyles._s8 } />
                                                                                    <span>
                                                                                        {t(
                                                  'welcomepage.header.enterprise',
                                                  { lng: 'en' }
                                                                                        )}
                                                                                    </span>
                                                                                </div>

                                                                                <span className = 'submenu-sub-text'>
                                                                                    {t(
                                                'welcomepage.header.customIntegrationDedicatedSupport'
                                                                                    )}
                                                                                </span>
                                                                            </a>

                                                                            <a
                                                                                className = 'list-group-item list-group-item-action list-active'
                                                                                href = {
                                                                                    '/products/video-conference/enterprise-selfhost'
                                                                                }>
                                                                                <div
                                                                                    style = { _inlineStyles._s7 }>
                                                                                    <img
                                                                                        src = 'images/enterprise-selfhost.svg'
                                                                                        style = { _inlineStyles._s8 } />
                                                                                    <span>
                                                                                        {t(
                                                  'welcomepage.header.enterpriseSelfHost'
                                                                                        )}
                                                                                    </span>
                                                                                </div>

                                                                                <span className = 'submenu-sub-text'>
                                                                                    {t(
                                                'welcomepage.header.hostVideoConferenceOnYourServers'
                                                                                    )}
                                                                                </span>
                                                                            </a>
                                                                            <h5 className = 'mt-20' />
                                                                            <a
                                                                                className = 'list-group-item list-group-item-action list-active'
                                                                                href = {
                                                                                    '/products/video-conference/features'
                                                                                }>
                                                                                <div
                                                                                    style = { _inlineStyles._s7 }>
                                                                                    <img
                                                                                        src = 'images/features.svg'
                                                                                        style = { _inlineStyles._s8 } />
                                                                                    <span>
                                                                                        {t(
                                                  'welcomepage.header.features'
                                                                                        )}
                                                                                    </span>
                                                                                </div>

                                                                                <span className = 'submenu-sub-text'>
                                                                                    {t(
                                                'welcomepage.header.simplifiedAPIReferences'
                                                                                    )}
                                                                                </span>
                                                                            </a>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>

                                                <li className = 'nav-item dropdown dropdown-hover position-static'>
                                                    <a
                                                        aria-expanded = 'false'
                                                        className = 'nav-a dropdown-toggle'
                                                        data-mdb-toggle = 'dropdown'
                                                        href = '/solutions'
                                                        id = 'navbarDropdown'
                                                        role = 'button'>
                                                        {t('welcomepage.header.solutions')}
                                                    </a>
                                                    <div
                                                        aria-labelledby = 'navbarDropdown'
                                                        className = 'dropdown-menu w-100 mt-0'>
                                                        <div className = 'container'>
                                                            <div
                                                                className = 'row my-4'
                                                                style = { _inlineStyles._s9 }>
                                                                <div className = 'col-md-6 col-lg-6 mb-3 mb-lg-0'>
                                                                    <div
                                                                        className = 'list-group list-group-flush'
                                                                        style = { _inlineStyles._s10 }>
                                                                        <h5>
                                                                            {t('welcomepage.header.useCases')}
                                                                        </h5>

                                                                        <a
                                                                            className = 'list-group-item list-group-item-action list-active'
                                                                            href = {
                                                                                '/solutions/usecases/videoconferencing'
                                                                            }>
                                                                            <div
                                                                                style = { _inlineStyles._s4 }>
                                                                                <img
                                                                                    src = 'images/vide-conference.svg'
                                                                                    style = { _inlineStyles._s8 } />
                                                                                <span>
                                                                                    {t(
                                                'welcomepage.header.videoConferencing'
                                                                                    )}
                                                                                </span>
                                                                            </div>

                                                                            <span className = 'submenu-sub-text'>
                                                                                {t(
                                              'welcomepage.header.customTailoredVideoMeetings'
                                                                                )}
                                                                            </span>
                                                                        </a>
                                                                        <a
                                                                            className = 'list-group-item list-group-item-action list-active'
                                                                            href = {
                                                                                '/solutions/usecases/livestreaming'
                                                                            }>
                                                                            <div
                                                                                style = { _inlineStyles._s7 }>
                                                                                <img
                                                                                    src = 'images/live-stream.svg'
                                                                                    style = { _inlineStyles._s8 } />
                                                                                <span>
                                                                                    {t(
                                                'welcomepage.header.liveStreaming'
                                                                                    )}
                                                                                </span>
                                                                            </div>

                                                                            <span className = 'submenu-sub-text'>
                                                                                {t(
                                              'welcomepage.header.highQualityLiveEventStreaming'
                                                                                )}
                                                                            </span>
                                                                        </a>
                                                                        <a
                                                                            className = 'list-group-item list-group-item-action list-active'
                                                                            href = '/solutions/usecases/virtualclassrooms'>
                                                                            <div
                                                                                style = { _inlineStyles._s7 }>
                                                                                <img
                                                                                    src = 'images/virtual-classroms.svg'
                                                                                    style = { _inlineStyles._s8 } />
                                                                                <span>
                                                                                    {t(
                                                'welcomepage.header.virtualClassrooms'
                                                                                    )}
                                                                                </span>
                                                                            </div>

                                                                            <span className = 'submenu-sub-text'>
                                                                                {t(
                                              'welcomepage.header.interactiveVirtualLearningSolutions'
                                                                                )}
                                                                            </span>
                                                                        </a>

                                                                        <a
                                                                            className = 'list-group-item list-group-item-action list-active'
                                                                            href = {
                                                                                '/solutions/usecases/virtualevents'
                                                                            }>
                                                                            <div
                                                                                style = { _inlineStyles._s7 }>
                                                                                <img
                                                                                    src = 'images/virtual-events.svg'
                                                                                    style = { _inlineStyles._s8 } />
                                                                                <span>
                                                                                    {t(
                                                'welcomepage.header.virtualEvents'
                                                                                    )}
                                                                                </span>
                                                                            </div>

                                                                            <span className = 'submenu-sub-text'>
                                                                                {t(
                                              'welcomepage.header.engagingVirtualEventExperiences'
                                                                                )}
                                                                            </span>
                                                                        </a>
                                                                        <a
                                                                            className = 'list-group-item list-group-item-action list-active'
                                                                            href = { '/solutions/usecases/ekyc' }>
                                                                            <div
                                                                                style = { _inlineStyles._s7 }>
                                                                                <img
                                                                                    src = 'images/ekyc.svg'
                                                                                    style = { _inlineStyles._s8 } />
                                                                                <span>
                                                                                    {t('welcomepage.header.videoKYC')}
                                                                                </span>
                                                                            </div>

                                                                            <span className = 'submenu-sub-text'>
                                                                                {t(
                                              'welcomepage.header.smoothVideoOnboardingExperience'
                                                                                )}
                                                                            </span>
                                                                        </a>

                                                                        <a
                                                                            className = 'list-group-item list-group-item-action list-active'
                                                                            href = { '/solutions/usecases/webinars' }>
                                                                            <div
                                                                                style = { _inlineStyles._s7 }>
                                                                                <img
                                                                                    src = 'images/webinars.svg'
                                                                                    style = { _inlineStyles._s8 } />
                                                                                <span>
                                                                                    {t('welcomepage.header.webinars')}
                                                                                </span>
                                                                            </div>

                                                                            <span className = 'submenu-sub-text'>
                                                                                {t(
                                              'welcomepage.header.webinarSessionsWithIndustryLeaders'
                                                                                )}
                                                                            </span>
                                                                        </a>

                                                                        <a
                                                                            className = 'list-group-item list-group-item-action list-active'
                                                                            href = {
                                                                                '/solutions/usecases/fundraising'
                                                                            }>
                                                                            <div
                                                                                style = { _inlineStyles._s7 }>
                                                                                <img
                                                                                    src = 'images/fundraising.svg'
                                                                                    style = { _inlineStyles._s8 } />
                                                                                <span>
                                                                                    {t(
                                                'welcomepage.header.fundraisingDonateOnline'
                                                                                    )}
                                                                                </span>
                                                                            </div>

                                                                            <span className = 'submenu-sub-text'>
                                                                                {t(
                                              'welcomepage.header.fundraiseEffortlesslyWithinVideoConferences'
                                                                                )}
                                                                            </span>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                                <div className = 'col-md-6 col-lg-6 mb-3 mb-lg-0'>
                                                                    <div className = 'list-group list-group-flush'>
                                                                        <h5>
                                                                            {t('welcomepage.header.industries')}
                                                                        </h5>

                                                                        <a
                                                                            className = 'list-group-item list-group-item-action list-active'
                                                                            href = { '/solutions/industries/edtech' }>
                                                                            <div
                                                                                style = { _inlineStyles._s11 }>
                                                                                <img
                                                                                    src = 'images/edtech.svg'
                                                                                    style = { _inlineStyles._s8 } />{' '}
                                                                                <span>
                                                                                    {t('welcomepage.header.edTech')}
                                                                                </span>
                                                                            </div>

                                                                            <span className = 'submenu-sub-text'>
                                                                                {t(
                                              'welcomepage.header.engagingOnlineLearningForEducators'
                                                                                )}
                                                                            </span>
                                                                        </a>
                                                                        <a
                                                                            className = 'list-group-item list-group-item-action list-active'
                                                                            href = '/solutions/industries/fitness'>
                                                                            <div
                                                                                style = { _inlineStyles._s11 }>
                                                                                <img
                                                                                    src = 'images/fitness.svg'
                                                                                    style = { _inlineStyles._s8 } />
                                                                                <span>
                                                                                    {t('welcomepage.header.fitness')}
                                                                                </span>
                                                                            </div>

                                                                            <span className = 'submenu-sub-text'>
                                                                                {t(
                                              'welcomepage.header.virtualSolutionForHomeFitness'
                                                                                )}
                                                                            </span>
                                                                        </a>
                                                                        <a
                                                                            className = 'list-group-item list-group-item-action list-active'
                                                                            href = {
                                                                                '/solutions/industries/healthcare'
                                                                            }>
                                                                            <div
                                                                                style = { _inlineStyles._s11 }>
                                                                                <img
                                                                                    src = 'images/telehealth.svg'
                                                                                    style = { _inlineStyles._s8 } />
                                                                                <span>
                                                                                    {t(
                                                'welcomepage.header.telehealth'
                                                                                    )}
                                                                                </span>
                                                                            </div>

                                                                            <span className = 'submenu-sub-text'>
                                                                                {t(
                                              'welcomepage.header.tailoredSolutionsForYourHealthcareNeeds'
                                                                                )}
                                                                            </span>
                                                                        </a>
                                                                        <img
                                                                            alt = 'solutions-header-thumb'
                                                                            src = 'images/solutions-header-thumb.png'
                                                                            width = { 300 } />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>

                                                <li className = 'nav-item dropdown dropdown-hover position-static'>
                                                    <a
                                                        aria-expanded = 'false'
                                                        className = 'nav-a dropdown-toggle'
                                                        data-mdb-toggle = 'dropdown'
                                                        href = '/developers'
                                                        id = 'navbarDropdown'
                                                        role = 'button'>
                                                        {t('welcomepage.header.developers')}
                                                    </a>
                                                    <div
                                                        aria-labelledby = 'navbarDropdown'
                                                        className = 'dropdown-menu w-100 mt-0'>
                                                        <div className = 'container'>
                                                            <div
                                                                className = 'row my-4'
                                                                style = { _inlineStyles._s9 }>
                                                                <div className = 'col-md-6 col-lg-6 mb-3 mb-lg-0'>
                                                                    <div className = 'list-group list-group-flush'>
                                                                        <h5>
                                                                            {' '}
                                                                            {t('welcomepage.header.getStarted')}
                                                                        </h5>
                                                                        <a
                                                                            className = 'list-group-item list-group-item-action list-active'
                                                                            href = { '/developers/sdks' }>
                                                                            <div
                                                                                style = { _inlineStyles._s7 }>
                                                                                <img
                                                                                    src = 'images/sdks.svg'
                                                                                    style = { _inlineStyles._s8 } />
                                                                                <span>
                                                                                    {' '}
                                                                                    {t(
                                                'welcomepage.header.preBuiltSDKs'
                                                                                    )}
                                                                                </span>
                                                                            </div>

                                                                            <span className = 'submenu-sub-text'>
                                                                                {t(
                                              'welcomepage.header.accelerateDevelopmentWithPrebuiltSDKs'
                                                                                )}
                                                                            </span>
                                                                        </a>
                                                                        <a
                                                                            className = 'list-group-item list-group-item-action list-active'
                                                                            href = 'https://docs.v-empower.com/docs/MeetHour-API'
                                                                            rel = 'noreferrer'
                                                                            target = '_blank'>
                                                                            <div
                                                                                style = { _inlineStyles._s7 }>
                                                                                <img
                                                                                    src = 'images/documentation.svg'
                                                                                    style = { _inlineStyles._s8 } />
                                                                                <span>
                                                                                    {' '}
                                                                                    {t(
                                                'welcomepage.header.documentation'
                                                                                    )}
                                                                                </span>
                                                                            </div>
                                                                            <span className = 'submenu-sub-text'>
                                                                                {t(
                                              'welcomepage.header.simplifiedAPIReferences'
                                                                                )}
                                                                            </span>
                                                                        </a>{' '}
                                                                        <img
                                                                            alt = 'developers-api-documentation'
                                                                            height = { 216 }
                                                                            src = 'images/video-conference3.jpg'
                                                                            width = { 300 } />
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className = 'col-md-6 col-lg-6 mb-3 mb-lg-0'
                                                                    style = { _inlineStyles._s12 }>
                                                                    <div className = 'list-group list-group-flush'>
                                                                        <h5>
                                                                            {' '}
                                                                            {t('welcomepage.header.resources')}
                                                                        </h5>

                                                                        <a
                                                                            className = 'list-group-item list-group-item-action list-active'
                                                                            href = { '/blog' }>
                                                                            <div
                                                                                style = { _inlineStyles._s7 }>
                                                                                <img
                                                                                    src = 'images/blog.svg'
                                                                                    style = { _inlineStyles._s8 } />
                                                                                <span>
                                                                                    {' '}
                                                                                    {t('welcomepage.header.blog')}
                                                                                </span>
                                                                            </div>

                                                                            <span className = 'submenu-sub-text'>
                                                                                {t(
                                              'welcomepage.header.stayuptodateWithOurBlog'
                                                                                )}
                                                                            </span>
                                                                        </a>
                                                                        <a
                                                                            className = 'list-group-item list-group-item-action list-active'
                                                                            href = {
                                                                                '/developers/resources/api-status'
                                                                            }>
                                                                            <div
                                                                                style = { _inlineStyles._s7 }>
                                                                                <img
                                                                                    src = 'images/api-status.svg'
                                                                                    style = { _inlineStyles._s8 } />
                                                                                <span>
                                                                                    {' '}
                                                                                    {t(
                                                'welcomepage.header.apiStatus'
                                                                                    )}
                                                                                </span>
                                                                            </div>

                                                                            <span className = 'submenu-sub-text'>
                                                                                {t(
                                              'welcomepage.header.systemHealthStatusandUpdates'
                                                                                )}
                                                                            </span>
                                                                        </a>

                                                                        <a
                                                                            className = 'list-group-item list-group-item-action list-active'
                                                                            href = {
                                                                                'http://kb.meethour.io/category/how-to'
                                                                            }
                                                                            rel = 'noreferrer'
                                                                            target = '_Blank'>
                                                                            <div
                                                                                style = { _inlineStyles._s7 }>
                                                                                <img
                                                                                    src = 'images/knowledge-base.svg'
                                                                                    style = { _inlineStyles._s8 } />
                                                                                <span>
                                                                                    {' '}
                                                                                    {t(
                                                'welcomepage.header.knowledgeBase'
                                                                                    )}
                                                                                </span>
                                                                            </div>{' '}
                                                                            <span className = 'submenu-sub-text'>
                                                                                {t(
                                              'welcomepage.header.systemHealthStatusandUpdates'
                                                                                )}
                                                                            </span>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>

                                                <li className = 'nav-item dropdown dropdown-hover position-static'>
                                                    <a
                                                        aria-expanded = 'false'
                                                        className = 'nav-a dropdown-toggle'
                                                        data-mdb-toggle = 'dropdown'
                                                        href = '/products/video-conference/pricing'
                                                        id = 'navbarDropdown'>
                                                        {t('welcomepage.header.pricing')}
                                                    </a>
                                                    <div
                                                        aria-labelledby = 'navbarDropdown'
                                                        className = 'dropdown-menu mt-0'
                                                        style = { _inlineStyles._s13 }>
                                                        <div
                                                            className = 'container'
                                                            style = { _inlineStyles._s14 }>
                                                            <div className = 'row my-4'>
                                                                <div className = 'col-md-12 col-lg-12 mb-3 mb-lg-0'>
                                                                    <div className = 'list-group list-group-flush'>
                                                                        <a
                                                                            className = 'list-group-item list-group-item-action list-active'
                                                                            href = {
                                                                                '/products/video-conference/pricing'
                                                                            }>
                                                                            <div
                                                                                style = { _inlineStyles._s4 }>
                                                                                <img
                                                                                    src = 'images/meethour.svg'
                                                                                    style = { _inlineStyles._s8 } />
                                                                                <span>
                                                                                    {' '}
                                                                                    {t(
                                                'welcomepage.header.videoConference'
                                                                                    )}
                                                                                </span>
                                                                            </div>

                                                                            <span className = 'submenu-sub-text'>
                                                                                {t(
                                              'welcomepage.header.videoConferencePricing'
                                                                                )}
                                                                            </span>
                                                                        </a>

                                                                        <a
                                                                            className = 'list-group-item list-group-item-action list-active'
                                                                            href = { 'https://mycaly.io/pricing' }
                                                                            rel = 'noreferrer'
                                                                            target = '_blank'>
                                                                            <div
                                                                                style = { _inlineStyles._s4 }>
                                                                                <img
                                                                                    src = 'images/mycaly.svg'
                                                                                    style = { _inlineStyles._s8 } />
                                                                                <span>
                                                                                    {' '}
                                                                                    {t('welcomepage.header.myCaly', {
                                                                                        lng: 'en'
                                                                                    })}
                                                                                </span>
                                                                            </div>

                                                                            <span className = 'submenu-sub-text'>
                                                                                {t(
                                              'welcomepage.header.myCalyPricing'
                                                                                )}
                                                                            </span>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>

                                            <ul className = 'float-right-desktop d-flex'>
                                                <li style = { styleWeb.languageContainer }>
                                                    <LanguagesDropdown />
                                                </li>
                                                <li
                                                    className = 'd-flex align-items-center'
                                                    style = { styleWeb.headerliRight }>
                                                    <a href = '/joinmeeting'>
                                                        {' '}
                                                        {t('welcomepage.header.joinAMeeting')}
                                                    </a>
                                                </li>
                                                {logoutDocument}
                                            </ul>
                                        </div>
                                    </div>

                                </nav>
                            </MediaQuery>
                        </>
                    )}
                </div>
            </header>
        ) : (
            <header
                className = { 'fixed-top d-flex align-items-center' }
                id = 'header'>
                <div className = 'container d-flex align-items-center'>
                    <div
                        className = 'logo mr-auto'
                        style = { styleWeb.width300 }>
                        <Watermark />
                    </div>

                    {interfaceConfig && !interfaceConfig.disablePrejoinHeader && (
                        <>
                            <MediaQuery minWidth = { 1000 }>
                                <nav
                                    className = 'nav-menu d-none d-lg-block desktop-width '
                                    style = { styleWeb.width100 }>
                                    <ul className = 'float-left-desktop'>
                                        <li>
                                            <a href = '#features'>
                                                {' '}
                                                {t('welcomepage.header.features')}
                                            </a>
                                        </li>
                                        <li className = 'drop-down'>
                                            <a href = ''>{t('welcomepage.header.solutions')}</a>
                                            <ul className = 'drop-down1'>
                                                <li>
                                                    <a href = '/explore/hospitals.html'>
                                                        {t('welcomepage.forHospitals')}
                                                    </a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className = 'drop-down'>
                                            <a href = '#pricing'>
                                                {t('welcomepage.header.pricing')}
                                            </a>
                                            <ul className = 'drop-down1'>
                                                <li>
                                                    <a href = 'https://meethour.io/#pricing'>
                                                        {t('welcomepage.freePlan', { lng: 'en' })}
                                                    </a>
                                                    <a
                                                        href = 'https://repo.meethour.io/landing/pro.html?location=meethour_homepage_pricing_menu'
                                                        rel = 'noreferrer'
                                                        target = '_blank'>
                                                        {t('welcomepage.proPlan', { lng: 'en' })}
                                                    </a>
                                                    <a
                                                        href = 'https://repo.meethour.io/landing/developer.html?location=meethour_homepage_pricing_menu'
                                                        rel = 'noreferrer'
                                                        target = '_blank'>
                                                        {t('welcomepage.developerPlan', { lng: 'en' })}
                                                    </a>
                                                    <a
                                                        href = 'https://repo.meethour.io/landing/enterprise.html?location=meethour_homepage_pricing_menu'
                                                        rel = 'noreferrer'
                                                        target = '_blank'>
                                                        {t('welcomepage.enterpriseSelfHostPlan', {
                                                            lng: 'en'
                                                        })}
                                                    </a>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                    <ul className = 'float-right-desktop' />
                                    <li style = { styleWeb.languageContainer }>
                                        <LanguagesDropdown />
                                    </li>
                                    <li
                                        className = 'd-flex align-items-center'
                                        style = { styleWeb.headerliRight }>
                                        <a href = '/joinmeeting'>
                                            {t('welcomepage.header.joinAMeeting')}
                                        </a>
                                    </li>
                                    {logoutDocument}
                                </nav>
                            </MediaQuery>
                        </>
                    )}
                </div>
            </header>
        ))}
        </React.Fragment>
    );
};
